import { ComponentPropsWithoutRef, ReactElement } from 'react';

import classNames from 'classnames';

import { attachComponentData } from '@backstage/core-plugin-api';

import { Flex } from '@spotify-internal/encore-web';

import { PAGE_CONTENT_MAIN_KEY } from './composition';

import styles from './ContentMain.module.css';

export type PageContentMainProps = ComponentPropsWithoutRef<typeof Flex>;

export const ContentMain = ({
  className,
  direction = 'column',
  ...props
}: PageContentMainProps): ReactElement => (
  <Flex
    {...props}
    direction={direction}
    className={classNames(styles.root, className)}
  />
);

attachComponentData(ContentMain, PAGE_CONTENT_MAIN_KEY, true);
